/* import __COLOCATED_TEMPLATE__ from './conditional-in-element.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./conditional-in-element.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());